export const tweenConfigs = {
    camera: {
        duration: 100,
        ease: "Linear"
    },
    modal: {
        show: {
            duration: 200,
            ease: 'Power2'
        },
        hide: {
            duration: 100,
            ease: 'Linear'
        }
    },
    sideMenu: {
        show: {
            // duration: 800,
            // ease: "Quint.easeIn"
            duration: 300,
            ease: "Sine.easeInOut"
        },
        hide: {
            duration: 150,
            ease: "Linear"
        }
    },
    lockScreen: {
        show: {
            duration: 150,
            ease: "Linear"
        },
        hide: {
            duration: 150,
            ease: "Linear"
        }
    },
    actionButtons: {
        show: {
            duration: 200,
            ease: "Back"
        },
        hide: {
            duration: 200,
            ease: "Back"
        } 
    },
    winChips: {
        duration: 2000,
        ease: "Quint.easeOut",
        delay: 10
    },
    winText:{
        duration: 500,
        ease: "Linear"
    },
    playerChips: {
        show: {
            duration: 150,
            ease: "Linear"
        },
        stack: {
            duration: 150,
            ease: "Linear"
        }
    },
    flopCards: {
        first: {
            duration: 300,
            ease: "Linear",
        },
        second: {
            duration: 300,
            ease: "Linear",
        }
    },
    idleSeatHide: {
        duration: 500,
        ease: "Linear"
    },
    miniTableMenu: {
        show: {
            duration: 200,
            ease: 'Power2'
        },
        hide: {
            duration: 200,
            ease: 'Power2'
        }
    }
}